module.exports = __webpack_public_path__ + "img/苏州日嘉兴.9063debb.jpg";